import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridGap: theme.spacing(3),
    gridTemplateRows: '1fr',
    padding: theme.spacing(3),
    overflow: 'auto',
    height: '100%',
    WebkitOverflowScrolling: 'touch',
    overscrollBehavior: 'auto',

    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '2fr 1fr',
    },
    [theme.breakpoints.only('md')]: {
      gridTemplateColumns: '3fr 2fr',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      // display: 'flex',
      // flexDirection: 'column',
      display: 'block',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 0),
    },

    '& > .section': {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        overflow: 'hidden',
      },
      [theme.breakpoints.down('sm')]: {
        flexGrow: 'initial',
        '&:not(:last-of-type)': {
          marginBottom: theme.spacing(2),
        },
      },
    },

    '& .progress': {
      '&-container': {
        flexGrow: 2,
      },
    },

    '& .tabs': {
      '&-container': {
        flexGrow: 1,
      },
    },

    '& .progress, & .tabs': {
      '&-content': {
        height: '100%',
        overflow: 'auto',

        [theme.breakpoints.up('md')]: {
          ...theme.globalStyles.scrollbar(theme),
        },
        [theme.breakpoints.down('sm')]: {
          // maxHeight: 'calc(100vh - 148px)',
          maxHeight: 'calc(100vh - 136px)',
        },
      },

      '&-panel': {
        height: '100%',
      },
    },

    '& .box-error': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      },
      '&-icon': {
        color: theme.palette.custom.feedback.warning,
        marginBottom: theme.spacing(1),
      },
      '&-msg': {
        color: theme.palette.text.secondary,
      },
      '&-retry': {
        marginTop: theme.spacing(3),
      },
    },
  },

  tabContainer: {
    minHeight: theme.spacing(7),
  },
}));

export default styles;
